import gql from 'graphql-tag'

export const DELETE = gql`
  mutation scholarship_delete($id: ID!) {
    scholarshipDelete(id: $id) {
      id
    }
  }
`
